import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import { getPremiumBoletoExpiringInfo, BOLETO_EXPIRING, BOLETO_EXPIRED } from 'commons/utils/accountUtils';
import { currentUserSelector, useAppStore } from 'stores/appStore';

const useStyles = makeStyles()(() => ({
  alertMessage: {
    padding: '0px',
  },
  alertInnerMessage: {
    lineHeight: '1rem',
  },
}));

// COMPONENT
function HeaderPremium() {
  const { classes } = useStyles();
  const currentUser = useAppStore(currentUserSelector);
  const premiumBoletoExpiringInfo = getPremiumBoletoExpiringInfo(currentUser);

  return (
    <>
      {premiumBoletoExpiringInfo != null && premiumBoletoExpiringInfo.status === BOLETO_EXPIRING && (
        <Alert
          severity="warning"
          classes={{
            message: classes.alertMessage,
          }}
        >
          <div className={classes.alertInnerMessage}>
            Seu boleto irá vencer em breve. Vencimento:{' '}
            {premiumBoletoExpiringInfo.nextPaymentDate.format('DD/MM/YY')}
          </div>
          <div className={classes.alertInnerMessage}>Se você já realizou o pagamento, por favor ignore</div>
          <b className={classes.alertInnerMessage}>Você pode obter o PIX/boleto pelo app.</b>
        </Alert>
      )}

      {premiumBoletoExpiringInfo != null && premiumBoletoExpiringInfo.status === BOLETO_EXPIRED && (
        <Alert
          severity="error"
          classes={{
            message: classes.alertMessage,
          }}
        >
          <Typography variant="body1" component="div" className={classes.alertInnerMessage}>
            Pagamento atrasado. Vencimento: {premiumBoletoExpiringInfo.nextPaymentDate.format('DD/MM/YY')}
            <Typography variant="body2" className={classes.alertInnerMessage}>
              Caso não haja pagamento seu acesso será desativado dia{' '}
              {premiumBoletoExpiringInfo.nextPaymentDate.add(4, 'days').format('DD/MM/YY')}
            </Typography>
          </Typography>
          <b className={classes.alertInnerMessage}>Você pode obter o PIX/boleto pelo app.</b>
        </Alert>
      )}
    </>
  );
}

export default React.memo(HeaderPremium);
